/* ============================================================
   LOYWIS THEME - Shared JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Occasion Tabs ─────────────────────────────────────── */
  function initOccasionTabs() {
    document.querySelectorAll('.lw-occasion-tabs').forEach(function (tabsEl) {
      var section = tabsEl.closest('.lw-occasion-section');
      if (!section) return;

      tabsEl.querySelectorAll('.lw-occ-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          // Deactivate all tabs
          tabsEl.querySelectorAll('.lw-occ-tab').forEach(function (t) {
            t.classList.remove('lw-occ-tab--active');
          });
          // Hide all panels
          section.querySelectorAll('.lw-occ-panel').forEach(function (p) {
            p.hidden = true;
          });
          // Activate clicked tab
          tab.classList.add('lw-occ-tab--active');
          // Show target panel
          var target = tab.dataset.tab;
          var panel = section.querySelector('[data-panel="' + target + '"]');
          if (!panel) return;
          panel.hidden = false;

          // Tab-wise "View all" - point header link at this tab's target
          var va = section.querySelector('[data-occ-viewall]');
          if (va) {
            var url = panel.getAttribute('data-viewall') || '';
            if (url) { va.setAttribute('href', url); va.hidden = false; }
            else { va.hidden = true; }
          }

          // Refresh slider arrow state for the now-visible panel.
          // Call synchronously (forces layout after un-hiding) + once more
          // on the next frame in case images/fonts shift the track width.
          panel.querySelectorAll('.lw-occ-slider').forEach(function (sl) {
            if (!sl._lwUpdate) return;
            sl._lwUpdate();
            window.requestAnimationFrame(sl._lwUpdate);
          });
        });
      });
    });
  }

  /* ── Occasion Product Sliders ──────────────────────────── */
  function initOccasionSliders() {
    document.querySelectorAll('.lw-occ-slider').forEach(function (slider) {
      var track = slider.querySelector('.lw-occ-track');
      if (!track) return;
      var prev = slider.querySelector('.lw-occ-arrow--prev');
      var next = slider.querySelector('.lw-occ-arrow--next');

      function step() { return Math.max(track.clientWidth * 0.85, 220); }

      function update() {
        var overflowing = track.scrollWidth > track.clientWidth + 2;
        slider.classList.toggle('lw-occ-slider--has-overflow', overflowing);
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', function () {
        window.requestAnimationFrame(update);
      });

      slider._lwUpdate = update;
      update();
    });
  }

  /* ── Cart Count Updater ──────────────────────────────── */
  function lwUpdateCartCount(count) {
    var cartBtn = document.getElementById('lw-hdr-cart-btn');
    if (!cartBtn) return;

    var badge = cartBtn.querySelector('.lw-hdr__cart-count');

    if (count < 1) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'lw-hdr__cart-count';
      badge.setAttribute('aria-hidden', 'true');
      cartBtn.appendChild(badge);
    }
    badge.textContent = count;
    // Liquid renders the badge with a `hidden` attribute when the cart starts
    // empty; make sure it becomes visible after the first add.
    badge.hidden = false;
    badge.removeAttribute('hidden');
    badge.style.display = '';
  }

  /* ── Entrance animation reveal (adds .lw-animated to .lw-animate) ── */
  function initReveal() {
    var els = document.querySelectorAll('.lw-animate');
    if (!els.length) return;
    function reveal(el) { el.classList.add('lw-animated'); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); obs.unobserve(e.target); }
        });
      }, { threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(reveal);
    }
    // Failsafe: never leave an entrance-animated section permanently hidden
    setTimeout(function () { els.forEach(reveal); }, 1500);
  }

  /* ── Wishlist hearts (delegated - works on every page & after AJAX) ── */
  function initGlobalWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.lw-product-card__wish');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var isWished = btn.classList.contains('lw-wished');
      btn.classList.toggle('lw-wished', !isWished);
      btn.innerHTML = isWished ? LWIcon('heart-outline', 18) : LWIcon('heart', 18);
      btn.style.color = isWished ? '' : '#C4952A';
      btn.setAttribute('aria-pressed', isWished ? 'false' : 'true');
    });
  }

  /* ── Add to Cart ─────────────────────────────────────── */
  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.lw-product-card__atc');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId  = btn.dataset.variantId;
      var cartAction = btn.dataset.cartAction || 'go_to_cart';
      if (!variantId) return;

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function () {
          if (cartAction === 'go_to_cart') {
            window.location.href = '/cart';
          } else {
            btn.innerHTML = LWIcon('check', 16) + ' Added';
            btn.style.background = '#E8F8EE';
            btn.style.color = '#1B7F4F';
            setTimeout(function () {
              btn.textContent = 'Add to Cart';
              btn.style.background = '';
              btn.style.color = '';
              btn.disabled = false;
            }, 1800);
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) { lwUpdateCartCount(cart.item_count); })
              .catch(function () {});
          }
        })
        .catch(function () {
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        });
    });
  }

  /* ── Floating WhatsApp popup dismiss ──────────────────── */
  function initWaFloat() {
    document.querySelectorAll('.lw-wa-float').forEach(function (el) {
      var popup = el.querySelector('.lw-wa-float__popup');
      if (!popup) return;
      // Auto-hide popup after 6 seconds
      setTimeout(function () {
        popup.style.transition = 'opacity 0.4s';
        popup.style.opacity = '0';
        setTimeout(function () { popup.style.display = 'none'; }, 400);
      }, 6000);
      // Click on popup to dismiss
      popup.addEventListener('click', function () {
        popup.style.display = 'none';
      });
    });
  }

  /* ── Init on DOM ready ─────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initAddToCart();
    initGlobalWishlist();
    initReveal();
    initOccasionTabs();
    initOccasionSliders();
    initWaFloat();
  }

})();
